export enum DeviceRepsColumnId {
  DeviceRepName = 'device_rep_name',
  Specialty = 'specialty',
  EmailAddresses = 'email_addresses',
  ContactNumbers = 'contact_numbers',
  SupplierTenantName = 'supplier_tenant_name',
  Status = 'status',
  Actions = 'actions',
}
